import React, { useState } from 'react';

import { Alert, Box, Collapse, Link, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// keep in sync with SalesStatsRepository in the bento order module
const RevenueLegend = () => {
    const [open, setOpen] = useState(false);

    return (
        <Box>
            <Link component="button" variant="caption" underline="hover" onClick={ () => setOpen(prevState => !prevState) }
                  sx={ { display: 'inline-flex', alignItems: 'center', gap: 0.5 } }>
                <InfoOutlinedIcon sx={ { fontSize: 14 } }/>
                { open ? 'Ukryj sposób liczenia' : 'Jak liczymy obrót?' }
            </Link>

            <Collapse in={ open }>
                <Alert severity="info" variant="outlined" icon={ false } sx={ { mt: 1 } }>
                    <Typography variant="body2" sx={ { fontWeight: 600, mb: 0.5 } }>
                        Obrót brutto = Σ (cena sprzedaży + dopłata pracodawcy) × liczba sztuk
                    </Typography>
                    <Box component="ul" sx={ { m: 0, pl: 2.5, typography: 'body2' } }>
                        <li>Cena sprzedaży to cena zapłacona przez klienta po promocjach i rabatach. Część opłacana przez pracodawcę też jest wliczana.</li>
                        <li>Liczymy zamówienia zakończone i częściowo zwrócone. Anulowane, nieopłacone i zwrócone w całości są pomijane.</li>
                        <li>Zwrócone i anulowane pozycje nie są wliczane, nawet jeśli reszta zamówienia została opłacona.</li>
                        <li>Kaucje i usługi nie wchodzą do obrotu.</li>
                        <li>Sprzedaż stacjonarna jest liczona według daty zakupu, rezerwacje według daty złożenia zamówienia.</li>
                        <li>Po wybraniu punktów sprzedaży rezerwacje są pomijane, bo nie są przypisane do punktu.</li>
                        <li>Średni koszyk = obrót brutto / liczba transakcji.</li>
                        <li>Zamówienia ze zwrotem to odsetek zamówień ze sprzedaży stacjonarnej, w których zwrócono co najmniej jedną pozycję.</li>
                        <li>Zmiana procentowa porównuje wybrany okres z poprzednim okresem o tej samej długości.</li>
                    </Box>
                </Alert>
            </Collapse>
        </Box>
    );
};

export default RevenueLegend;
